import React from 'react';
import PropTypes from 'prop-types';

import {
  ResponsiveContainer,
  BarChart as Chart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Cell,
} from 'recharts';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';

import getChartColors from './chartColors';

const CustomTooltip = ({ active, payload, label, ...other }) => {
  if (!active || !payload || !payload.length) return null;

  const filtered = payload.filter((item) => item.value > 0);

  return (
    <Paper
      elevation={3}
      sx={(theme) => ({
        p: 2,
        minWidth: 160,
        backgroundColor: 'var(--color-surface-elevated)',
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Typography variant="subtitle2" gutterBottom>
        {label}
      </Typography>

      {filtered.map((item) => (
        <Box
          key={item.dataKey}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={0.5}
        >
          <Box display="flex" alignItems="center" gap={1}>
            {/*<Box*/}
            {/*  sx={{*/}
            {/*    width: 10,*/}
            {/*    height: 10,*/}
            {/*    backgroundColor: item.color,*/}
            {/*    borderRadius: '50%',*/}
            {/*  }}*/}
            {/*/>*/}

            <Typography variant="body2">
              {item.dataKey}
            </Typography>
          </Box>

          <Typography variant="body2" fontWeight={600}>
            {item.value}
          </Typography>
        </Box>
      ))}
    </Paper>
  );
};

const BarChart = ({ data = [], datasets = [] }) => {
  const theme = useTheme();
  const colors = getChartColors(theme, data.length || 5);

  return (
    <ResponsiveContainer width="100%" height={350}>
      <Chart data={data} barCategoryGap="25%">
        <CartesianGrid vertical={false} strokeDasharray="3 3" />

        <XAxis
          dataKey="name"
          tickLine={false}
          axisLine={{ stroke: theme.palette.divider }}
          tick={{ fill: theme.palette.text.secondary }}
        />

        <YAxis
          allowDecimals={false}
          tickLine={false}
          axisLine={{ stroke: theme.palette.divider }}
          tick={{ fill: theme.palette.text.secondary }}
        />

        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'var(--color-hover-surface)' }} />

        {datasets.map((item) => (
          <Bar key={item.key} dataKey={item.key}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Bar>
        ))}
      </Chart>
    </ResponsiveContainer>
  );
};

BarChart.propTypes = {
  data: PropTypes.array,
  datasets: PropTypes.array,
};

export default BarChart;
